import Head from "next/head";
import { useRouter } from "next/router";
import { markdownToPlainText } from "@lib/strapi/content";

/**
 * MedicalTherapy JSON-LD for treatment pages (P10, 2026-09-14).
 *
 * The semantically correct markup for a treatment page — FAQPage was
 * considered and rejected: since 2023-08 Google shows FAQ rich results only
 * for well-known authoritative gov/health sites, while MedicalTherapy feeds
 * the same medical entity graph the site-wide Physiotherapy schema sits in.
 * `provider` repeats the business name + url EXACTLY as BusinessJsonLd
 * declares them, so the two nodes reconcile to one entity.
 */
export default function MedicalTherapyJsonLd({
  entity,
}: {
  entity: { title?: string; teaser?: string };
}) {
  const { asPath } = useRouter();
  if (!entity?.title) return null;

  const data = {
    "@context": "https://schema.org",
    "@type": "MedicalTherapy",
    name: entity.title,
    ...(entity.teaser ? { description: markdownToPlainText(entity.teaser) } : {}),
    url: `https://myphysiowave.gr${asPath.split(/[?#]/)[0]}`,
    provider: {
      "@type": ["MedicalBusiness", "Physiotherapy"],
      name: "Physiowave Therapy",
      url: "https://myphysiowave.gr",
    },
  };

  return (
    <Head>
      <script
        type="application/ld+json"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
      />
    </Head>
  );
}
